import { render, staticRenderFns } from "./FigmaTest.vue?vue&type=template&id=bcd2516e&"
import script from "./FigmaTest.vue?vue&type=script&lang=js&"
export * from "./FigmaTest.vue?vue&type=script&lang=js&"
import style0 from "./FigmaTest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports